"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import { Divider as UiDivider } from "@/components/ui";
import { useAuthFlow } from "./auth-flow-context";
import { AuthMethodId } from "./types";
export interface AuthDividerProps {
  children?: ReactNode;
  className?: string;
}
export function AuthDivider(t0) {
  const $ = _c(3);
  const {
    children: t1,
    className
  } = t0;
  const children = t1 === undefined ? "or" : t1;
  const {
    state
  } = useAuthFlow();
  if (state.isInSubFlow) {
    return null;
  }
  if (state.activeMethod === AuthMethodId.EMAIL_LINK) {
    return null;
  }
  const t2 = className ?? "md:py-2 my-0";
  let t3;
  if ($[0] !== children || $[1] !== t2) {
    t3 = <UiDivider className={t2}>{children}</UiDivider>;
    $[0] = children;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}